import React, { useEffect } from 'react';
import Menu from './components/Menu';
import { QueryClient, QueryClientProvider } from 'react-query';
import { combineReducers } from '@reduxjs/toolkit';
import { settingsReducer, actions } from './hooks/useSettings';
import { ConfigPageComponent } from '../core/types/common/ConfigPageComponent';
import { useDispatch } from 'react-redux';
import { ReactQueryDevtools } from 'react-query/devtools';
import productReservationTheme from './theme';
import { ThemeProvider } from '@material-ui/core';
import { actionsSecurity, productReservationSecurityReducer } from './hooks/useSecurity/useSecurityStore';

const queryClient = new QueryClient();

const ProductReservation = ({ link }: ConfigPageComponent) => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(actions.setAppLink(link));
        dispatch(actionsSecurity.loadSecurity('ProdReservation'));
    }, [dispatch]);

    return (
        <ThemeProvider theme={productReservationTheme}>
            <QueryClientProvider client={queryClient}>
                <Menu />
                <ReactQueryDevtools initialIsOpen />
            </QueryClientProvider>
        </ThemeProvider>
    );
};

export default ProductReservation;

export const productReservationReducer = combineReducers({
    settings: settingsReducer,
    security: productReservationSecurityReducer,
});
